<template>
  <div :class="$style['order-css']">
    <v-tabs :class="$style.tabs"
            v-model="tabs"
            fixed-tabs background-color="#847f7f" dark>
      <v-tab
          v-for="n in items"
          :key="n">
        {{ n }}
      </v-tab>
      <v-tabs-slider color="#96e763"></v-tabs-slider>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <OrderList :update-list="getData" v-if="oracle.getToken() && listNow.length>0" :list="listNow"></OrderList>
        <div v-else-if="oracle.getToken()" :class="$style['empty-parent']">
          <div :class="$style['empty']">
            <v-icon>search_off</v-icon>
            <span>سفارشی ثبت نشده است</span>
          </div>
        </div>
        <div v-else :class="$style['empty-parent']">
          <div :class="$style['empty']">
            <v-icon>search_off</v-icon>
            <span>لطفا وارد حساب کاربری خود شوید</span>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <OrderList :update-list="getData"  v-if="oracle.getToken() && listOld.length>0" :list="listOld"></OrderList>
        <div v-else-if="oracle.getToken()" :class="$style['empty-parent']">
          <div :class="$style['empty']">
            <v-icon>search_off</v-icon>
            <span>سفارشی ثبت نشده است</span>
          </div>
        </div>
        <div v-else :class="$style['empty-parent']">
          <div :class="$style['empty']">
            <v-icon>search_off</v-icon>
            <span>لطفا وارد حساب کاربری خود شوید</span>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <div style="height: 100px"></div>
  </div>
</template>
<script>
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import OrderList from "@/pages/OrderList";
import oracle from "@/utils/oracle";

export default {
  name: "Orders",
  components: {
    OrderList
  },
  data: () => ({
    items: ['سفارشات جاری', 'سفارشات قبلی'],
    tabs: null,
    listNow: [],
    listOld: [],
    oracle: oracle,
  }),
  methods: {
    getData(){
      oracle.axios(
          "order/getList",
          {"limit_by": 500, "offset_by": 0},
          this.fetchList
      );
    },
    fetchList(response) {
      let allList = response.data
      let lNow = []
      let lOld = []
      for (let i = 0; i < allList.length; i++) {
        if (allList[i].order_refund == 1) {
          allList[i].status_label = "ریفاند به کیف پول"
          allList[i].status_color = '#ffab04'
        } else if (allList[i].order_refund == 2) {
          allList[i].status_label = "ریفاند به حساب بانکی"
          allList[i].status_color = '#ffab04'
        } else {
          allList[i].status_color = '#222222'
          switch (allList[i].order_state) {
            case 0:
              allList[i].status_label = 'ثبت شده'
              break
            case 1:
              allList[i].status_color = '#ff0000'
              allList[i].status_label = 'لغو شده'
              break
            case 2:
              allList[i].status_label = 'جستجوی پیک'
              break
            case 3:
              allList[i].status_label = 'پذیرش میاره'
              break
            case 4:
              allList[i].status_label = 'پیک یافت شد'
              break
            case 5:
              allList[i].status_label = 'پیک در فروشگاه'
              break
            case 6:
              allList[i].status_color = '#7ec352'
              if (allList[i].review == null) {
                allList[i].status_btn = "ثبت نظر و امتیاز"
              } else {
                allList[i].status_label = 'تحویل مشتری'
              }
              break
          }
        }
        if (allList[i].order_state == 6 || allList[i].order_state == 1) {
          lOld.push(allList[i])
        } else {
          lNow.push(allList[i])
        }
      }
      this.listNow = lNow
      this.listOld = lOld
    },
  },
  mounted() {
    if (oracle.getToken() == null) return
    try {
      let status = this.$route.query.status
      if (status != null && status == "success") {
        oracle.clearBasket()
      }
    } catch (ignored) {
    }
    this.getData()
  },
};
</script>
<style module>

.order-css {
  height: 100%;
  overflow: scroll;
}

.order-css .tabs {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.order-css a {
  text-decoration: none;
}

.order-css .card-tabs-div {
  margin-top: 100px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.order-css .card-tabs-div button {
  border-radius: 20px;
  background-color: #7ec352 !important;
  color: white !important;
}

.order-css .card-tabs-div .v-icon.v-icon {
  font-size: 80px;
  margin-top: 100px;
  color: #7ec352;
  margin-bottom: 10px
}

.order-css .empty i {
  color: #7ec352;
  font-size: 5em;
  margin: 0 auto;
}

.order-css .empty span {
  font-size: 13px;
}

.order-css .empty-parent {
  width: 100%;
  margin-top: 80%;
}

.order-css .empty {
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.order-css .empty .v-icon {
  font-size: 4em;
}

.order-css .empty span {
  font-size: 12px;
}
</style>
